import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import Seo from "@/components/Seo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Lock } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-ink p-5">
      <Seo title="Admin Login" noindex path="/login" />
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <span className="font-heading text-2xl font-black tracking-tighter text-white">
            EAZY<span className="text-[#00E676]">CAR</span>TRACK
          </span>
          <p className="mt-2 text-sm text-zinc-400">Fleet Admin</p>
        </div>
        <form onSubmit={submit} className="space-y-4 border border-white/10 bg-white p-8" data-testid="login-form">
          <div className="flex items-center gap-2 text-zinc-900">
            <Lock className="h-5 w-5" />
            <h1 className="font-heading text-xl font-bold">Sign in</h1>
          </div>
          {error && <div className="rounded-lg bg-red-50 p-3 text-sm text-red-700" data-testid="login-error">{error}</div>}
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" className="mt-1 h-12" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" className="mt-1 h-12" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit" className="flex h-12 w-full items-center justify-center gap-2 rounded-full bg-ink font-bold text-white disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
